import { Card } from "@circleco/compass/components/Card";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

interface AvatarSuggestedQuestionsProps {
  onSelect: (question: string) => void;
  questions: string[];
}

export const AvatarSuggestedQuestions = ({
  onSelect,
  questions,
}: AvatarSuggestedQuestionsProps) => (
  <div className="flex shrink-0 flex-col gap-2">
    {questions.map(question => (
      <Card.Root
        key={question}
        onMouseDown={event => event.preventDefault()}
        onClick={() => onSelect(question)}
      >
        <Card.Body className="px-4 py-3">
          <span className="flex w-full items-start gap-3">
            <Icon name="message" size="sm" className="mt-0.5 shrink-0" />
            <Typography variant="body-sm" component="span">
              {question}
            </Typography>
          </span>
        </Card.Body>
      </Card.Root>
    ))}
  </div>
);
